// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_header.scss
// module id = 40
// module chunks = 0